import LeaseholdProperties from '../views/LeaseholdProperties';
import LeaseholdPropertyWrapper from '../views/LeaseholdPropertyWrapper';
import LeaseholdProperty from '../views/LeaseholdProperty';
import LeaseholdGroundRentTransactions from '../views/LeaseholdGroundRentTransactions';
import LeaseholdServiceChargeTransactions from '../views/LeaseholdServiceChargeTransactions';
import LeaseholdPropertyPay from '../views/LeaseholdPropertyPay';
import LeaseholdPropertySummary from '../views/LeaseholdPropertySummary';
import LeaseholdPropertyNotifications from '../views/LeaseholdPropertyNotifications';
import LeaseholdEstateTransactions from '../views/LeaseholdEstateTransactions';
import LeaseholdPropertyWorksOrders from '../views/LeaseholdPropertyWorksOrders';
import LeaseholdPropertyRepairs from '../views/LeaseholdPropertyRepairs';
import LeaseholdPropertyReportRepair from '../views/LeaseholdPropertyReportRepair';

export default [
    {
        path: '/leasehold-properties',
        name: 'leasehold-properties',
        component: LeaseholdProperties,
        meta: {
            title: 'Leasehold Properties',
        },
    },
    {
        path: '/leasehold-properties/:id',
        component: LeaseholdPropertyWrapper,
        meta: {
            title: 'Leasehold Property',
        },
        pathToRegexpOptions: {
            strict: true,
        },
        children: [
            // Property
            {
                path: '',
                name: 'leasehold-property',
                component: LeaseholdProperty,
                pathToRegexpOptions: {
                    strict: false,
                },
            },
            {
                path: 'ground-rent-transactions',
                name: 'leasehold-property-ground-rent-transactions',
                component: LeaseholdGroundRentTransactions,
                pathToRegexpOptions: {
                    strict: true,
                },
                beforeEnter: (to, from, next) => {
                    if(! window.meta.features.leaseholders.ground_rent_transactions) {
                        return next({
                            name: 'leasehold-property',
                            params: {
                                id: to.params.id,
                            },
                        });
                    }
                    return next();
                },
            },
            {
                path: 'service-charge-transactions',
                name: 'leasehold-property-service-charge-transactions',
                component: LeaseholdServiceChargeTransactions,
                pathToRegexpOptions: {
                    strict: true,
                },
                beforeEnter: (to, from, next) => {
                    if(! window.meta.features.leaseholders.service_charge_transactions) {
                        return next({
                            name: 'leasehold-property',
                            params: {
                                id: to.params.id,
                            },
                        });
                    }
                    return next();
                },
            },
            {
                path: 'pay',
                name: 'leasehold-property-pay',
                component: LeaseholdPropertyPay,
                pathToRegexpOptions: {
                    strict: true,
                },
                beforeEnter: (to, from, next) => {
                    if(! window.meta.features.leaseholders.online_payments) {
                        return next({
                            name: 'leasehold-property',
                            params: {
                                id: to.params.id,
                            },
                        });
                    }
                    return next();
                },
            },
            // Block
            {
                path: 'estate-summary',
                name: 'leasehold-estate-summary',
                component: LeaseholdPropertySummary,
                pathToRegexpOptions: {
                    strict: true,
                },
            },
            {
                path: 'estate-notifications',
                name: 'leasehold-estate-notifications',
                component: LeaseholdPropertyNotifications,
                pathToRegexpOptions: {
                    strict: true,
                },
                beforeEnter: (to, from, next) => {
                    if(! window.meta.features.leaseholders.notifications) {
                        return next({
                            name: 'leasehold-property',
                            params: {
                                id: to.params.id,
                            },
                        });
                    }
                    return next();
                },
            },
            {
                path: 'estate-transactions',
                name: 'leasehold-estate-transactions',
                component: LeaseholdEstateTransactions,
                pathToRegexpOptions: {
                    strict: true,
                },
                beforeEnter: (to, from, next) => {
                    if(! window.meta.features.leaseholders.estate_transactions) {
                        return next({
                            name: 'leasehold-property',
                            params: {
                                id: to.params.id,
                            },
                        });
                    }
                    return next();
                },
            },
            {
                path: 'works-orders',
                name: 'leasehold-estate-works-orders',
                component: LeaseholdPropertyWorksOrders,
                pathToRegexpOptions: {
                    strict: true,
                },
                beforeEnter: (to, from, next) => {
                    if(! window.meta.features.leaseholders.works_orders) {
                        return next({
                            name: 'leasehold-property',
                            params: {
                                id: to.params.id,
                            },
                        });
                    }
                    return next();
                },
            },
            {
                path: 'repairs',
                name: 'leasehold-estate-repairs',
                component: LeaseholdPropertyRepairs,
                pathToRegexpOptions: {
                    strict: true,
                },
                beforeEnter: (to, from, next) => {
                    if(! window.meta.features.leaseholders.repairs) {
                        return next({
                            name: 'leasehold-property',
                            params: {
                                id: to.params.id,
                            },
                        });
                    }
                    return next();
                },
            },
            {
                path: 'request-repair',
                name: 'leasehold-estate-request-repair',
                component: LeaseholdPropertyReportRepair,
                pathToRegexpOptions: {
                    strict: true,
                },
                beforeEnter: (to, from, next) => {
                    if(! window.meta.features.leaseholders.fixflo) {
                        return next({
                            name: 'leasehold-property',
                            params: {
                                id: to.params.id,
                            },
                        });
                    }
                    return next();
                },
            },
        ],
    },
];
